import { makeStyles } from '@material-ui/core/styles';
import { memo } from 'react';
import { NavbarStyleContent, navbarStyleContent } from '../style-1/NavbarStyle1Content';

const useStyles = makeStyles(theme => navbarStyleContent(theme));

export default memo(NavbarStyleContent);
